import { useNavigate } from 'react-router-dom';
import { HOME_URL } from 'constants/navigation';

export const useRedirectToHome = () => {
    const navigate = useNavigate();

    return () => navigate(HOME_URL);
};
